// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__wougW","tab":"Tabs_tab__L33fj","tabActive":"Tabs_tabActive__HeniH"};